import React, { useEffect, useState } from "react";
import {
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  Checkbox,
  Input,
  Button,
} from "@chakra-ui/react";
import Select from "react-select";
import { stringConditions } from "../utils/SearchPickList";
import {
  itemUnitOptions,
} from "../utils/SearchPickList";
import { useDispatch } from "react-redux";
import { getCategoryList } from "../../../redux/reduxApi/admin/CategoryReduxApi";
import { getProduct } from "../../../redux/reduxApi/admin/ProductReduxApi";
import { setFilteredStatus } from "../../../redux/reduxSlice/admin/ProductSlice";
import { toast } from "react-toastify";
import useSubCategorySearch from "../../../hook/useSubCategorySearch";
import { AsyncPaginate } from "react-select-async-paginate";

export default function SearchProduct({
  isSearchDrawerOpen,
  closeDrawer,
  setRecordCount
}) {

  const dispatch = useDispatch();

  const [categoryOptions, setCategoryOptions] = useState([]);

  const filtersConfig = [
    { key: "itemName", label: "Item Name", optionsType: "string" },
    { key: "categoryName", label: "Category", optionsType: "category" },
    { key: "subCategory", label: "Sub Category", optionsType: "subcategory" },
    { key: "unit", label: "Unit", optionsType: "unit" },
  ];

  // Step 2: Initialize state
  const [filters, setFilters] = useState(
    filtersConfig.reduce((acc, f) => {
      acc[f.key] = {
        checked: false,
        condition: { label: "Is", value: "is" },
        showInput: false,
        value: "",
      };
      return acc;
    }, {})
  );

  const { loadSubCategories } = useSubCategorySearch({
    parentId: filters.categoryName.value?.value,
  });

  useEffect(() => {
    dispatch(getCategoryList())
      .then((res) => {
        const data = res.payload?.data || [];

        const parent = data
          .filter((item) => item.parentCategoryId === null)
          .map((item) => ({
            label: item.name,
            value: item.ROWID,
          }));

        setCategoryOptions(parent);

      });
  }, [dispatch]);



  const handleReset = () => {
    setFilters(
      filtersConfig.reduce((acc, f) => {
        acc[f.key] = {
          checked: false,
          condition: { label: "Is", value: "is" },
          showInput: false,
          value: "",
        };
        return acc;
      }, {})
    );
  };

  // Step 3: Handle checkbox
  const handleCheckboxChange = (key) => (e) => {
    const checked = e.target.checked;
    setFilters((prev) => ({
      ...prev,
      [key]: {
        ...prev[key],
        checked,
        condition: { label: "Is", value: "is" },
        showInput: checked,
        value: "",
      },
    }));
  };

  // Step 4: Handle condition change
  const handleSelectChange = (key) => (selected) => {
    const hideInputFor = ["is-empty", "is-not-empty"];
    setFilters((prev) => ({
      ...prev,
      [key]: {
        ...prev[key],
        condition: selected,
        showInput: !hideInputFor.includes(selected.value),
      },
    }));
  };

  // Step 5: Handle input value
  const handleValueChange = (key) => (value) => {
    setFilters((prev) => ({
      ...prev,
      [key]: { ...prev[key], value },
    }));
  };

  // Step 6: Reset drawer
  const handleOnClose = () => {
    setFilters(
      filtersConfig.reduce((acc, f) => {
        acc[f.key] = {
          checked: false,
          condition: { label: "Is", value: "is" },
          showInput: false,
          value: "",
        };
        return acc;
      }, {})
    );
    closeDrawer();
  };

  const getOptions = (type) => {
    switch (type) {
      case "category":
        return categoryOptions;
      case "unit":
        return itemUnitOptions;
      default:
        return [];
    }
  };


  const handleSearch = async () => {
    const search = [];

    filtersConfig.forEach(({ key }) => {
      const current = filters[key];

      if (current.checked) {
        let value =
          typeof current.value === "object"
            ? current.value.value
            : current.value;
        let operation = current.condition?.value || "is";

        search.push({
          field: key,
          operation,
          value: value ?? "",
        });
      }
    });

    if (search.length === 0) {
      toast.warning("Select at least one filter");
      return;
    }

    const query = {
      page: 1,        // ✅ number
      limit: 30,      // ✅ correct key
      search,
    };

    console.log("FINAL QUERY:", query); // debug

    sessionStorage.setItem("productSearchQuery", JSON.stringify(query));

    try {
      const res = await dispatch(getProduct(query));

      if (res?.error || res?.payload?.success === false) {
        toast.warning("No records found!");
        dispatch(setFilteredStatus(false));
        return;
      }

      dispatch(setFilteredStatus(true));
      toast.success("Filtered successfully");
      closeDrawer();

    } catch (err) {
      console.error(err);
      toast.error("Search failed");
    }
  };

  return (
    <Drawer
      isOpen={isSearchDrawerOpen}
      placement="right"
      size="xs"
      onClose={handleOnClose}
    >
      <DrawerOverlay />
      <DrawerContent>
        <DrawerCloseButton />
        <DrawerHeader>
          <div className="d-flex justify-content-start align-items-center gap-4">
            <span>Search Items</span>
            <button className="reset-btn" onClick={handleReset}> Reset</button>
          </div>
        </DrawerHeader>

        <DrawerBody>
          <form>
            {filtersConfig.map((filter) => {
              const { key, label, optionsType } = filter;
              const current = filters[key];
              return (
                <div className="mt-3" key={key}>
                  <Checkbox
                    isChecked={current.checked}
                    onChange={handleCheckboxChange(key)}
                  >
                    {label}
                  </Checkbox>

                  {current.checked && (
                    <>
                      <div className="mt-2">
                        <Select
                          options={stringConditions}
                          value={current.condition}
                          onChange={handleSelectChange(key)}
                        />
                      </div>

                      {current.showInput && (
                        <>
                          {
                            key === "subCategory" ? (
                              <AsyncPaginate
                                key={`sub-${filters.categoryName.value?.value || "none"}`}
                                className="mt-2"
                                loadOptions={loadSubCategories}
                                additional={{ page: 1 }}
                                debounceTimeout={300}
                                isClearable
                                placeholder={`Search ${label}`}
                                onChange={(opt) =>
                                  handleValueChange(key)(opt || null)
                                }
                                value={current.value || null}
                                isDisabled={!filters.categoryName.value}
                              />
                            ) : (
                              ["category", "unit"].includes(optionsType) ? (
                                <Select
                                  className="mt-2"
                                  isClearable
                                  options={getOptions(optionsType)}
                                  placeholder={`Select ${label}`}
                                  onChange={(opt) =>
                                    handleValueChange(key)(opt || null)
                                  }
                                  value={current.value || null}
                                />
                              ) : (
                                <Input
                                  className="mt-2"
                                  value={current.value || ""}
                                  onChange={(e) => handleValueChange(key)(e.target.value)}
                                />
                              ))}
                        </>
                      )}
                    </>
                  )}
                </div>
              );
            })}
          </form>
        </DrawerBody>
        <center>
          <DrawerFooter style={{ display: "inline-block" }}>
            <div className="d-flex gap-3">
              <button className="cancel-button" onClick={handleOnClose}>
                Cancel
              </button>
              <button className="main-btn" onClick={handleSearch}>
                <span className="inner-content">Search</span>
              </button>
            </div>
          </DrawerFooter>
        </center>
      </DrawerContent>
    </Drawer>
  );
}
